/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import { ComponentProps, forwardRef, memo } from 'react';

import { MenuProps } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

const createStylesMenuItem = makeStyles(() => ({
  root: {
    padding: '12px',
    position: 'relative',
    whiteSpace: 'normal',
    minHeight: '70px',
    flex: 1,
  },
  sizeSmall: {
    minHeight: '56px',
  },
}));

type StyledMenuItemProps = ComponentProps<typeof MenuItem> & {
  size?: 'small' | 'medium';
};

export const StyledMenuItem = memo(
  forwardRef<HTMLLIElement, StyledMenuItemProps>((props, ref) => {
    const { children, size = 'medium', ...otherProps } = props;
    const classes = createStylesMenuItem();
    return (
      <MenuItem
        {...otherProps}
        className={cx(classes.root, props.className || '', {
          [classes.sizeSmall]: size === 'small',
        })}
        ref={ref}
      >
        {children}
      </MenuItem>
    );
  }),
);

const StyledMenuComponent = memo<MenuProps>(props => (
  <Menu
    elevation={0}
    anchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

export const StyledMenu = withStyles({
  paper: {
    margin: '11px 0',
    border: '1px solid #EEEEEE',
    backgroundColor: '#FFFFFF',
    width: '251px',
    borderRadius: '6px',
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})(StyledMenuComponent);

export const createCreateMenuStyles = makeStyles(() => ({
  productItem: {},
  borderBottomInsideLink: {
    position: 'relative',
    display: 'flex',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      bottom: 0,
      right: 0,
      left: 0,
      height: '1px',
      backgroundColor: '#EEEEEE',
    },
    '&:last-child:after': {
      display: 'none',
    },
  },
  arrow: {
    fontSize: '24px !important',
    marginLeft: '10px',
  },
  arrowOpen: {
    transform: 'rotate(180deg)',
  },
}));
